import { useEffect } from "react"
import { useLazyGetFollowersQuery } from "appRedux/slices/userApiSlice"

export default function useFollowers(id?: number) {
  const [triggerGetFollowers, getFollowersResult] = useLazyGetFollowersQuery()


  useEffect(() => {
    fetchFollowers()
  }, [id])

  function fetchFollowers() {
    if (!id) return
    triggerGetFollowers(id)
  }

  return {
    followers: getFollowersResult?.data?.users || [],
    isFetching: getFollowersResult.isFetching,
    isError: getFollowersResult.isError
  }
}
